import type { Fetcher } from "../fetcher";
import type { GoodSearchResult } from "../entities/goods";
import type { ApiCollectionResponse } from "../types/api";

/**
 * Tenant-facing goods search. The backend resolves localised names via the
 * `X-Language` header, so results carry plain `name` strings. Returns merged
 * global + tenant-private leaf goods, ranked.
 */
export function createGoodsRepository(fetcher: Fetcher) {
  return {
    search: async (q: string, limit?: number): Promise<GoodSearchResult[]> => {
      const params = new URLSearchParams();
      if (q) params.set("q", q);
      if (limit != null) params.set("limit", String(limit));
      const qs = params.toString();
      const res = await fetcher<ApiCollectionResponse<GoodSearchResult>>(
        `/goods/search${qs ? `?${qs}` : ""}`,
      );
      return res.data?.items ?? [];
    },
  };
}
